import { render, staticRenderFns } from "./Oral-Exam.vue?vue&type=template&id=77814747&scoped=true"
import script from "./Oral-Exam.vue?vue&type=script&lang=js"
export * from "./Oral-Exam.vue?vue&type=script&lang=js"
import style0 from "./Oral-Exam.vue?vue&type=style&index=0&id=77814747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77814747",
  null
  
)

export default component.exports